import type { FeaturesDisplayModel } from '@core/models/features';
import { get } from '@shared/axios';

const fetchFeaturesByStudioSlug = async (studioSlug: string) =>
  await get<FeaturesDisplayModel[]>(`/api/customer/studios/${studioSlug}/features`);

export { fetchFeaturesByStudioSlug };
